module.exports = __webpack_public_path__ + "static/media/diageo-logo.147a16c0.png";